import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dropdown", "button"]

  declare readonly dropdownTarget: HTMLElement
  declare readonly buttonTarget: HTMLElement

  connect() {
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }

  toggle() {
    this.dropdownTarget.classList.toggle('opacity-0')
    this.dropdownTarget.classList.toggle('invisible')

    if (!this.dropdownTarget.classList.contains('invisible')) {
      this.removeUnseenBadge()
    }
  }

  hide() {
    this.dropdownTarget.classList.add('opacity-0', 'invisible')
  }

  handleClickOutside(event: Event) {
    if (!this.element.contains(event.target as Node)) {
      this.hide()
    }
  }

  private removeUnseenBadge() {
    const badge = this.buttonTarget.querySelector('.bg-red-500')
    if (badge) {
      badge.remove()
    }
  }
}
